// src/components/map/RouteLegend.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

// Expanded color palette matching Route.jsx
const COLORS = [
  "#3b82f6",
  "#ef4444",
  "#10b981",
  "#f59e0b",
  "#8b5cf6",
  "#ec4899",
  "#14b8a6",
  "#f97316",
  "#06b6d4",
  "#a855f7",
  "#84cc16",
  "#f43f5e",
  "#0ea5e9",
  "#eab308",
  "#22c55e",
  "#6366f1",
  "#fb923c",
  "#a78bfa",
  "#4ade80",
  "#facc15",
];

const RouteLegend = ({ routes, onRouteClick }) => {
  const navigate = useNavigate();

  if (!routes?.length) return null;

  const handleRouteNameClick = (route) => {
    if (route.id) {
      navigate(`/routes/${route.id}`);
    }
  };

  return (
    <div className="mb-4 p-4 bg-white dark:bg-gray-800 rounded-lg shadow-md transition-colors duration-300">
      <h3 className="text-lg font-semibold mb-3 text-gray-800 dark:text-white">
        Available Routes ({routes.length})
      </h3>
      <div className="flex flex-wrap gap-3">
        {routes.map((route, idx) => (
          <div key={route.id} className="flex items-center gap-2">
            {/* Color bar - focuses on map */}
            <button
              onClick={() => onRouteClick?.(route)}
              className="flex items-center px-3 py-1.5 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 cursor-pointer group"
              title={`Click to focus on ${route.name}`}
            >
              <div
                className="w-4 h-1 rounded transition-all duration-200 group-hover:h-2"
                style={{ backgroundColor: COLORS[idx % COLORS.length] }}
              />
            </button>
            {/* Route name - navigates to details */}
            <button
              onClick={() => handleRouteNameClick(route)}
              className="px-2 py-1 rounded hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
              title={`View details for ${route.name}`}
            >
              <span className="text-sm text-gray-700 hover:text-gray-900 hover:underline dark:text-gray-300 dark:hover:text-white">
                {route.name}
              </span>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RouteLegend;
